import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'

interface ModalDeleteMaterialProps extends ModalEditComponentProps { }

const ModalDeleteMaterial: React.FC<ModalDeleteMaterialProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/deleteProduct',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureUnableMaterial', '¿Seguro que quieres desactivar este material?'),
            subtitle: t('onceDeletedCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
            buttonAccept: t('unable', 'Desactivar')
        }} />
    )
}

export default ModalDeleteMaterial